import React from 'react';

const UserIcon = ({
    color = "#757575",
    height = 16,
    width = 16
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={`${width}`} height={`${height}`} viewBox="0 0 16 16" fill="none">
            <path d="M8 10C10.2091 10 12 8.20914 12 6C12 3.79086 10.2091 2 8 2C5.79086 2 4 3.79086 4 6C4 8.20914 5.79086 10 8 10Z" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            <path d="M2 13.5C3.21063 11.4081 5.40937 10 8 10C10.5906 10 12.7894 11.4081 14 13.5" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

export default UserIcon;